import { RangeFilters } from 'technical/range-filters/types';

export const hasInitialZoom = <Filters extends Record<string, any>>(
  isMobile: boolean,
  filters: RangeFilters<Filters>,
) => {
  if (!isMobile) {
    return false;
  }

  if (filters.filterType === 'date') {
    return (
      filters.dateRange &&
      filters.dateRange[1] &&
      filters.dateRange[0] &&
      filters.dateRange[1].diff(filters.dateRange[0], 'week') > 1
    );
  }

  if (filters.filterType === 'ring') {
    return (
      (!filters.ringRange?.[0] && !filters.ringRange?.[1]) ||
      Math.abs((filters.ringRange[1] ?? 0) - (filters.ringRange[0] ?? 0)) > 10
    );
  }

  return false;
};
